import { useState } from 'react';
import type { Invoice } from '@coreledger/shared-types';

interface Props {
  show: boolean;
  onClose: () => void;
  lorryReceipts: Invoice[];
  onImport: (selected: Invoice[]) => void;
}

export function LrImportModal({ show, onClose, lorryReceipts, onImport }: Props) {
  const [selectedIds, setSelectedIds] = useState<Set<string>>(new Set());

  if (!show) return null;

  function toggle(id: string) {
    setSelectedIds(prev => { const next = new Set(prev); next.has(id) ? next.delete(id) : next.add(id); return next; });
  }

  function handleImport() {
    onImport(lorryReceipts.filter(lr => selectedIds.has(lr.id)));
    setSelectedIds(new Set());
    onClose();
  }

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal" style={{ maxWidth: 700 }}>
        <div className="modal-header">
          <span className="modal-title">📦 Import from Lorry Receipts</span>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body" style={{ maxHeight: 420, overflowY: 'auto' }}>
          <p style={{ fontSize: '0.85rem', color: 'var(--text-2)', marginBottom: '1rem' }}>
            Select one or more lorry receipts. Their items and trips will be merged into this invoice.
          </p>
          {lorryReceipts.length === 0 ? (
            <div className="empty-state">
              <div className="empty-state-icon">🚚</div>
              <div className="empty-state-text">No lorry receipts found</div>
            </div>
          ) : (
            <table>
              <thead>
                <tr>
                  <th style={{ width: 36 }}></th>
                  <th>LR Number</th><th>Date</th><th>Party</th><th style={{ textAlign: 'right' }}>Total (₹)</th>
                </tr>
              </thead>
              <tbody>
                {lorryReceipts.map(lr => (
                  <tr key={lr.id} style={{ cursor: 'pointer' }} onClick={() => toggle(lr.id)}>
                    <td><input type="checkbox" readOnly checked={selectedIds.has(lr.id)} style={{ cursor: 'pointer' }} /></td>
                    <td style={{ fontWeight: 600 }}>{lr.invoiceNumber}</td>
                    <td>{lr.date}</td>
                    <td>{lr.partyName}</td>
                    <td style={{ textAlign: 'right' }}>₹{(lr.total ?? 0).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
        <div className="modal-footer">
          <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
          <button className="btn btn-primary" disabled={selectedIds.size === 0} onClick={handleImport}>
            Import Selected ({selectedIds.size})
          </button>
        </div>
      </div>
    </div>
  );
}
